import React from 'react';
import Navbar from '../components/Internal-nav';  
import SinkCard from '../components/sink-card';
import SinkData from '../data/sinkdata.json';
import ContactBanner from '../components/contact-banner';
import KometsBanner from '../components/komets-banner';

function Sinks() {
  return (
    <div className='App'>
    <header>
      <Navbar />
    </header>
    <div>
      <div className='inner-banner' style={{ backgroundImage: "url(../assets/example-sink-banner.jpg)"}}>
        <div className='banner-content'>
        <h1>Explore our Sink Options</h1>
        </div>
      </div>
     <> <div className='sink-list'>
      {SinkData ? 
             SinkData.Sinks.map((d,i) => (
              <SinkCard key={i} data={d}></SinkCard>
             ) 
             )
              : 'loading'}

      </div>
      </>

      <h2>More options available from Kohler and Elkay - Contact us for more information</h2>

      <ContactBanner></ContactBanner>


    </div>
    <KometsBanner></KometsBanner>
    </div>
  );
};
  
export default Sinks;